import { render, staticRenderFns } from "./side-layout.vue?vue&type=template&id=56b0bdae&scoped=true"
import script from "./side-layout.vue?vue&type=script&lang=ts"
export * from "./side-layout.vue?vue&type=script&lang=ts"
import style0 from "./side-layout.vue?vue&type=style&index=0&id=56b0bdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0bdae",
  null
  
)

export default component.exports